import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class TaxonomyName extends BasicDomain {
    static DEFAULTS = {
        name: '',
        typeId: '',
        taxonomy: null,
    }
  
    static VALIDATION_SCHEMA = yup.object({
        name: yup.string().required('Name is required'),
        typeId: yup.string().required('Type is required'),
        taxonomy: yup.object().required('Taxonomy is required')
    }).required();
  
    constructor(props) {
        super('Name', props, TaxonomyName.DEFAULTS);
    }
  
    getByPath = (path = []) => {
        let value = this;
        for (const key of path) {
            if (!value) return null;
            value = value.get(key);
        }
        return value;
    }
  }
  
  if (global.Parse.Object.registerSubclass) {
    global.Parse.Object.registerSubclass('Name', TaxonomyName);
  }